/**
 * Created by lizheng on 2018/6/6.
 */
import {
  INIT_CAMPAIGN,
  INIT_CAMPAIGN_LIST,
  INIT_MENU,
  INIT_CAMPAIGN_STORE,
  INIT_GOODS,
  RELOAD_GOODS,
  INIT_CART_NUM,
  CHANGE_BREAD,
  RECORD_ADDRESS,
  ADD_CART,
  LANGUAGE,
  REDUCE_CART,
  INIT_BUYCART,
  CLEAR_CART,
  RECORD_SHOPDETAIL,
  RECORD_USERINFO,
  GET_USERINFO,
  SEARCH_KEYWORD,
  CHANGE_PAGE,
  TOGGLE_AGREEMENT,
  INIT_AGREEMENT,
  CLEAR_GOODS,
  SHOW_RULE,
  HIDE_RULE,
  SET_TEMPNAME,
  ORDER_PRICE
} from './mutations-type.js'

import {setStore, getStore} from '../utils/storage'


export default {
  [SET_TEMPNAME](state,name){
    state.tempName = name
    // setStore('campaign', state.campaign)
  },
  [ORDER_PRICE](state,type){
    if(type==1){
      state.goods=state.goods.sort((a, b) => Number(b.price) - Number(a.price));
    }

    if(type==2){
      state.goods=state.goods.sort((a, b) => Number(a.price) - Number(b.price));
      
    }

  },
  [INIT_CAMPAIGN](state,campaign){
    state.campaign = { ...state.campaign, ...campaign}
    // setStore('campaign', state.campaign)
  },
  [INIT_CAMPAIGN_LIST](state,campaignList){
    state.campaignList = campaignList
    // setStore('campaign', state.campaign)
  },
  [CLEAR_GOODS](state){
    state.goods = [];
    // setStore('campaign', state.campaign)
  },
  [SHOW_RULE](state,data){
    state.rule = {...state.rule,...{'content':data,'show':true}};
    console.log(state.rule )
  },
  [HIDE_RULE](state,data){
    state.rule = {...state.rule,...{'content':'','show':false}};
    console.log(state.rule )
  },
  [INIT_AGREEMENT](state,agreement){
    state.global.agreement = agreement
    // setStore('campaign', state.campaign)
  },
  [INIT_CAMPAIGN_STORE](state){
    const campaign = getStore('campaign');
    if (campaign) {
      state.campaign = JSON.parse(campaign);
    }
  },
  [INIT_MENU](state,categories){
    state.categories = categories
    // setStore('categories', state.categories)
  },
  [INIT_GOODS](state, goods){
    state.goods = goods;
    // setStore('goods', state.goods)
  },
  [RELOAD_GOODS](state){
    const goods = getStore('goods');
    if (goods) {
      state.goods = JSON.parse(goods);
    }
  },
  [CHANGE_PAGE](state, currentPage){
    state.currentPage = currentPage
  },
  [INIT_CART_NUM](state, cartList){
    state.cartList = { ...state.cartList, ...cartList }
  },
  [CHANGE_BREAD](state, bread){
    state.bread = bread;
  },
  [TOGGLE_AGREEMENT](state, isShow){
    state.global.showAgreement = isShow;
  },
  [LANGUAGE](state,data){
    state.language = data
  },
  // 记录当前经度纬度
  [RECORD_ADDRESS](state, {
                     latitude,
                     longitude
                   }) {
    state.latitude = latitude;
    state.longitude = longitude;
  },

  [RECORD_SHOPDETAIL](state, detail) {
    state.shopDetail = detail;
  },
  [SEARCH_KEYWORD](state, searchKey){
    state.searchKey = searchKey
  },
  // 加入购物车
  [ADD_CART](state, {
               shopid,
               category_id,
               item_id,
               food_id,
               name,
               price,
               specs,
               packing_fee,
               sku_id,
               stock
             }) {
    let cart = state.cartList;
    let shop = cart[shopid] = (cart[shopid] || {});
    let category = shop[category_id] = (shop[category_id] || {});
    let item = category[item_id] = (category[item_id] || {});
    if (item[food_id]) {
      item[food_id]['num']++;
    } else {
      item[food_id] = {
        "num" : 1,
        "id" : food_id,
        "name" : name,
        "price" : price,
        "specs" : specs,
        "packing_fee" : packing_fee,
        "sku_id" : sku_id,
        "stock" : stock
      };
    }
    state.cartList = {...cart};
    //存入localStorage
    setStore('buyCart', state.cartList);
  },
  // 移出购物车
  [REDUCE_CART](state, {
                  shopid,
                  category_id,
                  item_id,
                  food_id,
                  name,
                  price,
                  specs,
                }) {
    let cart = state.cartList;
    let shop = (cart[shopid] || {});
    let category = (shop[category_id] || {});
    let item = (category[item_id] || {});
    if (item && item[food_id]) {
      if (item[food_id]['num'] > 0) {
        item[food_id]['num']--;
        state.cartList = {...cart};
        //存入localStorage
        // setStore('buyCart', state.cartList);
      } else {
        //商品数量为0，则清空当前商品的信息
        item[food_id] = null;
      }
    }
  },
  //网页初始化时从本地缓存获取购物车数据
  [INIT_BUYCART](state) {
    let initCart = getStore('buyCart');
    if (initCart) {
      state.cartList = JSON.parse(initCart);
    }
  },
  //清空当前商品的购物车信息
  [CLEAR_CART](state, shopid) {
    state.cartList[shopid] = null;
    state.cartList = {...state.cartList};
    // setStore('buyCart', state.cartList);
  },
  // 记录用户信息
  [RECORD_USERINFO](state, info) {
    state.user = info;
    state.login = true;
    // setStore('user_id', info.user_id);
  },
  //获取用户信息存入vuex
  [GET_USERINFO](state, info) {
    if (state.user && (state.user.username !== info.username)) {
      return;
    };
    if (!state.login) {
      return
    }
    if (!info.message) {
      state.user = {...info};
    } else {
      state.user = null;
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js